module.exports = __webpack_public_path__ + "assets/img/btn-detail-fe0e8215.png";